module.exports = ".social-feed-user-name {\n    color: #062b3e;\n    /* line-height: 1.38; */\n    /* font-weight: bold; */\n    font-family: Montserrat-Bold !important;\n    font-size: 16px;\n    margin-bottom: 5px;\n    text-transform: capitalize;\n  }\n\n  .filter-wrapper {\n    padding-top: 20px;\n  }\n\n  .action-section {\n    margin-top: 5px;\n  }\n\n  .follow-analyst {\n    height: 80vh;\n    overflow-y: auto;\n  }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/feature/main/roles-shared/components/future-research/future-research.component.css
// module id = ./src/app/feature/main/roles-shared/components/future-research/future-research.component.css
// module chunks = main